import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

export const fmtEUR = (n) => `€${Number(n || 0).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function LedgerTable({ entries, onDelete }) {
  return (
    <Card className="card-shadow-soft">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid="ledger-table">
          <thead className="bg-secondary text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3">Date</th>
              <th className="text-left px-4 py-3">Payer / Source</th>
              <th className="text-left px-4 py-3">Category</th>
              <th className="text-left px-4 py-3 hidden sm:table-cell">Method</th>
              <th className="text-right px-4 py-3">Amount</th>
              <th className="text-right px-4 py-3 hidden md:table-cell">Balance</th>
              <th className="px-2 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 && (
              <tr><td colSpan={7} className="text-center py-8 text-muted-foreground" data-testid="ledger-empty">No entries yet.</td></tr>
            )}
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-border" data-testid={`ledger-row-${e.id}`}>
                <td className="px-4 py-3 whitespace-nowrap">{e.entry_date}</td>
                <td className="px-4 py-3">
                  <div className="font-medium">{e.payer}</div>
                  {e.notes && <div className="text-xs text-muted-foreground">{e.notes}</div>}
                </td>
                <td className="px-4 py-3 capitalize">{e.category.replace("_", " ")}</td>
                <td className="px-4 py-3 hidden sm:table-cell capitalize">{e.method}</td>
                <td className={`px-4 py-3 text-right font-semibold ${e.entry_type === "expense" ? "text-red-700" : "text-green-700"}`}>
                  {e.entry_type === "expense" ? "−" : "+"}{fmtEUR(e.amount)}
                </td>
                <td className="px-4 py-3 text-right hidden md:table-cell">{fmtEUR(e.running_balance)}</td>
                <td className="px-2 py-3">
                  <Button size="icon" variant="ghost" onClick={() => onDelete(e.id)} data-testid={`ledger-del-${e.id}`}>
                    <Trash2 className="w-4 h-4 text-destructive" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
